import React from 'react'

export default function StrikeoutIcon({ color = null }) {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path
        d="M11.5 11.266c.133.394.127.857-.028 1.42-.286 1.02-.832 1.624-1.67 1.846-1.43.375-3.35-.414-4.276-1.332l-.46-.496-1.648 1.534.49.525c1.144 1.136 3.167 2.11 5.128 2.11.455 0 .906-.05 1.34-.166 1.607-.424 2.765-1.638 3.264-3.42.2-.72.24-1.39.152-2.02h-2.29zM18 7.89v2.25H0V7.89h5.266c-1.27-.907-2.125-2.283-1.47-4.49C4.427 1.28 5.867.48 6.965.18c2.323-.625 5.096.454 6.53 1.792l-1.536 1.644c-.986-.92-2.993-1.65-4.405-1.263-.804.218-1.327.77-1.6 1.685-.51 1.718.626 2.362 3.542 3.24.666.2 1.252.38 1.725.61H18z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
